import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux"
import cx from "classnames"
import {
} from "utils/constants"
import { getVrDraftsmen } from "requesters/userRequester";
import { assignVrDraftsman, unassignVrDraftsman } from "requesters/jobServiceRequester";
import Select from "react-select"
import { addIcon } from "components/Icons";
import UserAvatar from "components/UserAvatar"
import { getBaseUrl } from "../../../../reducers"

const SelectVrDraftsman = ({
  jobService, reloadData, readOnly
}) => {
  const {
    id,
    attributes: {
      primaryVrDraftsmanId, primaryVrDraftsmanName, primaryVrDraftsmanInitials, vrDraftingAssignments, secondaryVrDraftingAssignments
    }
  } = jobService
  const baseUrl = useSelector(getBaseUrl)
  const [vrDraftmanOptions, setVrDraftmanOptions] = useState([])
  const [primaryVrDraftman, setPrimaryVrDraftman] = useState()
  const [showAdditionalVrDraftsmanModal, setShowAdditionalVrDraftsmanModal] = useState(false)
  const [assignLoading, setAssignLoading] = useState(false)
  const [assignedVrDraftsmen, setAssignedVrDraftsmen] = useState([])

  const fetchVrDraftsmen = () => {
    getVrDraftsmen(baseUrl)
      .then(res => {
        if (res.status === 200) {
          const options = res.response
          setVrDraftmanOptions(options.filter(vrDraftsman => !assignedVrDraftsmen.includes(vrDraftsman.value)))
          setPrimaryVrDraftman(options.find(vrDraftsman => vrDraftsman.value === primaryVrDraftsmanId))
        }
      })
      // eslint-disable-next-line no-console
      .catch(err => console.log(err))
  }

  const onAssignVrDraftsman = (e, role) => {
    setAssignLoading(true)
    const params = { virtual_draftsman_id: e.value, role }
    assignVrDraftsman(baseUrl, id, params)
    .then(res => {
      if (res.status === 200) {
        window.location.reload()
      }
    })
    // eslint-disable-next-line no-console
    .catch(err => console.log(err))
    .finally(() => setAssignLoading(false))
  }

  const onUnassignVrDraftsman = vrDraftingAssignmentId => {
    setAssignLoading(true)
    unassignVrDraftsman(baseUrl, id, { draftsmen_assignment_id: vrDraftingAssignmentId })
    .then(res => {
      if (res.status === 200) {
        window.location.reload()
      }
    })
    // eslint-disable-next-line no-console
    .catch(err => console.log(err))
    .finally(() => setAssignLoading(false))
  }

  const VrDraftsmanModal = useCallback(() => {
    const closeModal = () => {
      setShowAdditionalVrDraftsmanModal(false)
    }

    return (
      <div
        onMouseLeave={closeModal}
        style={{ padding: "10px" }}
        className={cx("dropdown-menu shadow-sm", { "show-modal-select": showAdditionalVrDraftsmanModal })}>
        <Select
          isDisabled={readOnly}
          className="assign-dropdown"
          name="vr-draftsman"
          isSearchable
          placeholder="Secondary VR Draftsman"
          options={vrDraftmanOptions.filter(s => !assignedVrDraftsmen.includes(Number(s.value)))}
          onChange={e => {
            onAssignVrDraftsman(e, "secondary")
            setShowAdditionalVrDraftsmanModal(false)
          }} />
      </div>
    )
  }, [assignedVrDraftsmen, showAdditionalVrDraftsmanModal, vrDraftmanOptions])

  useEffect(() => {
    fetchVrDraftsmen()
  }, [primaryVrDraftsmanId])

  useEffect(() => {
    setAssignedVrDraftsmen(vrDraftingAssignments.map(ass => ass.data.attributes.vrDraftsmanId))
  }, [vrDraftingAssignments])

  return (
    <div className="assign mb-3">
      <div className="d-flex align-items-center">
        <div className="mr-1">
          Primary VR Draftsman
          {readOnly && ":"}
        </div>
        { readOnly ? (
          <div className="mr-3">
            <UserAvatar
              readOnly
              initials={primaryVrDraftsmanInitials}
              name={primaryVrDraftsmanName} />
          </div>
        ) : (
          <Select
            isDisabled={readOnly}
            className="assign-dropdown"
            name="vr-draftsman"
            isSearchable
            placeholder="Select VR Draftsman"
            options={vrDraftmanOptions.filter(vrDraftsman => !assignedVrDraftsmen.includes(Number(vrDraftsman.value)))}
            value={primaryVrDraftman}
            onChange={e => {
              setPrimaryVrDraftman(e)
              onAssignVrDraftsman(e, "primary")
            }} />
        )}
      </div>
      <div className="d-flex align-items-center mt-2" style={{ position: "relative" }}>
        <div className="mr-2">Assignees: </div>
        {secondaryVrDraftingAssignments && secondaryVrDraftingAssignments.map(ass => (
          <UserAvatar
            readOnly={readOnly}
            key={ass.id}
            initials={ass.data.attributes.vrDraftsmanInitials}
            name={ass.data.attributes.vrDraftsmanName}
            onRemove={() => {
              onUnassignVrDraftsman(id, { draftsmen_assignment_id: ass.id })
            }} />
        ))}
        {!readOnly && (
          <button
            disabled={assignLoading || readOnly}
            className="btn btn-sm"
            type="button"
            onClick={() => setShowAdditionalVrDraftsmanModal(!showAdditionalVrDraftsmanModal)}>
            <img src={addIcon} />
          </button>
        )}
        <VrDraftsmanModal />
      </div>
    </div>
  )
}
export default SelectVrDraftsman
